module.exports = __webpack_public_path__ + "d9ef728ff7acc76a1c8ba3f105d0ff8d.png";